import { useMemo } from 'react';
import { useLocation } from 'react-router';
import classnames from 'classnames/bind';
import { KeyboardArrowRightIcon } from 'tuui';
import { isPathActive } from 'modules/taboola-common-frontend-modules/utils/urlUtils';
import { InternalLink } from '../../../InternalLink';
import { getItemCaption } from '../../utils/getItemCaption';
import { getModuleLink } from '../../utils/getModuleLink';
import { IconWithCaption } from '../IconWithCaption/IconWithCaption';
import { NavigationSideItemMenu } from '../NavigationSideItemMenu/NavigationSideItemMenu';
import { PopupSideItem } from '../PopupSideItem/PopupSideItem';
import styles from './NavigationSideItem.module.scss';

const classNameBuilder = classnames.bind(styles);

export const NavigationSideItem = ({ item, subItems, collapsed, dataAutomationId }) => {
    const {
        icon: IconComponent,
        hideNavItem = false,
        caption,
        metricsAttributes,
        badgeComponent: BadgeComponent,
    } = item;
    const location = useLocation();
    const destinationPath = getModuleLink(item);
    const match = useMemo(
        () => subItems.some(subItem => !!isPathActive(location.pathname, getModuleLink(subItem))),
        [subItems, location.pathname]
    );

    if (hideNavItem) {
        return null;
    }

    if (subItems.length > 1) {
        return (
            <PopupSideItem
                item={{
                    ...item,
                    icon: IconComponent ? <IconComponent /> : null,
                    captionComponent: () => (
                        <div className={styles['submenu-caption']}>
                            {getItemCaption(item)}
                            <KeyboardArrowRightIcon />
                        </div>
                    ),
                    badgeComponent: BadgeComponent,
                }}
                active={match}
                collapsed={collapsed}
                dropdownComponent={NavigationSideItemMenu}
                dropdownProps={{ subItems }}
                popupClassName={styles['submenu-popup']}
                dataAutomationId={dataAutomationId}
            />
        );
    }

    return (
        <InternalLink className={classNameBuilder('container')} path={destinationPath} {...metricsAttributes}>
            <IconWithCaption
                item={{
                    icon: IconComponent ? <IconComponent /> : null,
                    caption,
                    badgeComponent: BadgeComponent,
                }}
                active={match}
                collapsed={collapsed}
                showHintOnActive
                dataAutomationId={dataAutomationId}
                stateful
            />
        </InternalLink>
    );
};
